import React, { type ReactElement } from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { Link as KitLink, type LinkPropsWithAsComponent } from '@pushwoosh/dumb-components';

export function RouterLink(props: Omit<LinkPropsWithAsComponent<LinkProps>, 'as'>): ReactElement {
  return <KitLink {...props} as={Link} />;
}
